import type { FC } from 'react';

import { IconButton } from '@mui/material';

import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';

import useStyles from './AddItemButton.styles';

export interface Props {
  onClick?: () => void;
  size?: 'medium' | 'small' | 'large';
  className?: string;
  testId?: string;
}

const AddItemButton: FC<Props> = ({ onClick, className, size = 'medium', testId }) => {
  const { classes, cx } = useStyles({ size });

  return (
    <IconButton className={cx(classes.root, className)} data-testid={testId} size={size} onClick={onClick}>
      <PlusIcon />
    </IconButton>
  );
};

export default AddItemButton;
